import { render, staticRenderFns } from "./SendOtherUserSafetyConfirm.vue?vue&type=template&id=3998bcdb&scoped=true&lang=pug"
import script from "./SendOtherUserSafetyConfirm.vue?vue&type=script&lang=ts"
export * from "./SendOtherUserSafetyConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SendOtherUserSafetyConfirm.vue?vue&type=style&index=0&id=3998bcdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3998bcdb",
  null
  
)

export default component.exports